import { Transform } from "class-transformer";
import { IsBoolean, IsOptional } from "class-validator";

export class FindOneMatchDto {
  @IsBoolean()
  @IsOptional()
  @Transform(({ value }) => value === "true")
  includeAdditionalMedia?: boolean | null;
}
